import React, { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import * as api from '../service/api';

function Account() {
    const history = useHistory()
    const [loading, setLoading] = useState(true)
    const [contratos, setContratos] = useState([])

    const border = <hr className="border-orange-700 mt-3" />

    useEffect(() => {
        api.retornarContratosEUsuarios()
            .then(res => {
                if (!res.success) {
                    if (res.code == 0) {
                        history.replace('/logout')
                    }
                    return
                }
                setContratos(res.contratos)
            })
            .finally(() => setLoading(false))
    }, [])

    return (
        <div className="container mx-auto px-4 pt-10 pb-16 max-w-3xl">
            <h1 className="text-3xl font-bold">Conta</h1>
            {border}

            {/* Usuários */}
            <section className="flex flex-col lg:flex-row gap-4 px-1 mt-6">
                <div className="lg:w-1/3">
                    <span className="text-lg font-semibold text-gray-300">Usuários Júpiter TV</span>
                </div>
                <div className="flex flex-col gap-3 w-full">
                    {loading && <span className="text-gray-400 text-base">Carregando...</span>}
                    {contratos.map((contrato) => (
                        <div key={contrato.usuario_id} className="bg-gray-800 rounded-lg p-4 flex flex-col gap-1 border border-gray-700">
                            <span className="text-base font-medium text-white">{contrato.usuario}</span>
                            <span className="text-sm text-gray-400">
                                {contrato.pacotes.map(p => p.descricao).join(', ')}
                            </span>
                            <button
                                className="mt-2 text-sm text-blue-400 text-left hover:text-blue-300 hover:underline w-fit"
                                onClick={() => history.push('/app/password', { usuario_id: contrato.usuario_id, usuario: contrato.usuario })}
                            >
                                Alterar senha
                            </button>
                        </div>
                    ))}
                </div>
            </section>

            {border}

            {/* Configurações */}
            <section className="flex flex-col lg:flex-row gap-4 px-1 mt-6">
                <div className="lg:w-1/3">
                    <span className="text-lg font-semibold text-gray-300">Configurações</span>
                </div>
                <ul className="flex flex-col gap-2 w-full">
                    {[
                        { to: '/app/device_manager', label: 'Meus dispositivos' },
                        { to: '/app/ativar', label: 'Ativar um dispositivo' },
                        { to: '/app/user_access', label: 'Atividade recente na conta' },
                        { to: '/app/logout_all', label: 'Encerrar sessão em todos os dispositivos' },
                    ].map(({ to, label }) => (
                        <li key={to}>
                            <Link
                                className="flex items-center gap-2 text-base text-blue-400 hover:text-blue-300 hover:underline"
                                to={to}
                            >
                                {label}
                            </Link>
                        </li>
                    ))}
                </ul>
            </section>

            {border}

            {/* App banner */}
            <div className="mt-6 p-5 bg-gray-800 border border-gray-700 rounded-lg flex flex-col gap-1">
                <span className="text-sm text-gray-400">Assista também pelo celular</span>
                <a
                    className="text-base font-semibold text-orange-400 hover:text-orange-300 hover:underline"
                    href="https://play.google.com/store/apps/details?id=br.com.jupiter.jupitertv"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Baixar o App do Júpiter TV →
                </a>
            </div>
        </div>
    )
}

export default Account;